export default __webpack_public_path__ + "static/media/avasta.52f0e64f.svg";